import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-view-questionnaire-trainee-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './view-questionnaire-trainee-dialog.component.html',
  styleUrl: './view-questionnaire-trainee-dialog.component.css'
})
export class ViewQuestionnaireTraineeDialogComponent {

}
